import Yup from 'yup';

export const getErrorProps = fieldErrors => ({
  FormHelperTextProps: { error: !!fieldErrors },
  error: !!fieldErrors,
  helperText: fieldErrors,
});

export const optionalNumberSchema = Yup.number().transform(
  (value, original) => {
    return original === '' ? 0 : value;
  },
);



// WEBPACK FOOTER //
// ./src/util/validation.js